<template>
    <b-card class="position-relative">
        <v-overlay-loader :loading="detailLoading || printLoading" :text="printLoading ? 'PDF hazırlanıyor...' : 'Detay yükleniyor'"/>
        <b-modal id="tonnage-edit" :title=" EditTonnage.IrsaliyeNo  +' - İrsaliye Tonaj Bilgisi Güncelle'" no-close-on-esc no-close-on-backdrop>
            <counter-tonnage-edit v-model="EditTonnage"></counter-tonnage-edit>
            <template #modal-footer><v-executer :loading="counterTonnageLoading" :action="editTonnage"></v-executer></template>
        </b-modal>
        <b-modal id="bitis-firm-edit" :title=" EditIrsaliyeSeferBitisFirm.IrsaliyeNo  +' - İrsaliye Bitiş Firması Düzenle'" no-close-on-esc no-close-on-backdrop>
            <bitis-firm-edit v-model="EditIrsaliyeSeferBitisFirm"></bitis-firm-edit>
            <template #modal-footer><v-executer :loading="counterTonnageLoading" :action="editBitisFirm"></v-executer></template>
        </b-modal>
        <b-modal id="irsaliye-sefer-extra-route-add" :title=" IrsaliyeSeferExtraRoute.ParentIrsaliyeNo + ' - İrsaliyesine bağlı ek sefer işlemi'" no-close-on-esc no-close-on-backdrop>
            <irsaliye-sefer-extra-route-add v-model="IrsaliyeSeferExtraRoute"></irsaliye-sefer-extra-route-add>
            <template #modal-footer><v-executer :loading="counterTonnageLoading" :action="editSeferExtraRoute"></v-executer></template>
        </b-modal>
        <b-modal id="change-request-detail" :title="ChangeRequestDetail.IrsaliyeNo + ' İrsaliyesine Bağlı Değişiklik Talepleri'" hide-footer size="lg" no-close-on-esc no-close-on-backdrop>
            <change-request-detail-view v-model="ChangeRequestDetail"></change-request-detail-view>
        </b-modal>
        <!-- YAZDIRMA BASLIGI: yalnizca @media print icinde gorunur.
             Ekranda alttaki stats-box kutulari kullanilir; yazdirmada onlar gizlenir. -->
        <div class="d-none d-print-block print-header">
            <div class="d-flex align-items-center justify-content-between mb-1">
                <img src="~@/assets/images/logo/ozturelogo.png" alt="Vişne Madencilik" style="height:48px">
                <div class="text-right">
                    <div class="h5 mb-0">Nakliyeci Sefer Mutabakati</div>
                    <div class="text-muted small">Yazdirilma: {{ printDate }}</div>
                </div>
            </div>
            <div v-if="isDraft" class="alert alert-warning py-50 px-1 mb-1 small">
                <b>TASLAK</b> — bu belge henuz onaylanmamis kullanicinin girdisiyle olusmustur.
            </div>
            <table class="table table-sm table-bordered mb-1">
                <tbody>
                    <tr>
                        <th style="width:22%">Tasiyici</th>
                        <td>{{ IrsaliyeGroup.CarrierCariName }}</td>
                        <th style="width:18%">Referans</th>
                        <td>{{ IrsaliyeGroup.ReferenceNo }}</td>
                    </tr>
                    <tr>
                        <th>Tarih Araligi</th>
                        <td>{{ (IrsaliyeGroup.StartDate || '*') }} — {{ (IrsaliyeGroup.EndDate || '*') }}</td>
                        <th>Durum</th>
                        <td>{{ IrsaliyeGroup.StatusStr }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- Yazdir butonu: sadece ekranda gorunur, print stilinde gizlenir. -->
        <div class="d-flex justify-content-end mb-1 no-print">
            <button class="btn btn-outline-primary" :disabled="printLoading" v-on:click="printPage">
                <b-spinner v-if="printLoading" small class="mr-50"></b-spinner>
                <feather-icon v-else icon="PrinterIcon" class="mr-50"></feather-icon>
                {{ printLoading ? "Hazırlanıyor..." : "Yazdır" }}
            </button>
        </div>
        <div class="row no-print">
            <div class="col-md-12 mb-1 ">
                <v-stats-box text="Durum" variant="success" icon="info" :value="IrsaliyeGroup.StatusStr" ></v-stats-box>
            </div>
            <div class="col-md-6 mb-1 ">
                <v-stats-box text="Referans No" variant="warning" icon="info" :value="IrsaliyeGroup.ReferenceNo" ></v-stats-box>
            </div>
            <div class="col-md-6 mb-1">
                <v-stats-box text="Taşıyıcı Cari Adı" variant="success" icon="handshake" :value="IrsaliyeGroup.CarrierCariName" ></v-stats-box>
            </div>
            
            <div class="col-md-6 mb-1 ">
                <v-stats-box text="Tarih Aralığı" variant="danger" icon="event" :value="(IrsaliyeGroup.StartDate || '*') +' - ' + (IrsaliyeGroup.EndDate || '*')" ></v-stats-box>
            </div>
            <div class="col-md-6 mb-1 ">
                <v-stats-box text="Oluşturulma Tarihi" variant="primary" icon="event" :value="IrsaliyeGroup.CreateTime" ></v-stats-box>
            </div>
            
        </div>
        <hr class="no-print">
        <div v-if="IrsaliyeGroupDetailStats.length>0 && (IrsaliyeGroup.Status == 9 || IrsaliyeGroup.Status ==10 || IrsaliyeGroup.Status ==11)" class="row mb-2">
                <h2>Özet Fiyat Bilgisi</h2>
                <table class="table table-sm align-middle">
                    <thead>
                        <tr>
                            <th>Varış Noktası</th>
                            <th>Taşıma Durumu</th>
                            <th>Malzeme</th>
                            <th>Araç Tipi</th>
                            <th class="text-nowrap">Tonaj Kaynağı</th>
                            <th>Toplam Tonaj</th>
                            <th>Birim Fiyat</th>
                            <th>Toplam Tutar</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="(data, index) in IrsaliyeGroupDetailStats">
                            <tr :key="index">
                                    <td class="text-nowrap">{{ data.CustomerName }}</td>
                                    <td class="text-nowrap">{{ data.VehicleTransportStatus }}</td>
                                    <td class="text-nowrap">{{ data.MaterialName }}</td>
                                    <td class="text-nowrap">{{ data.VehicleType }}</td>
                                    <td class="text-nowrap">
                                        <b-badge :variant="tonnageBadge(data).variant" pill>
                                            {{ tonnageBadge(data).label }}
                                        </b-badge>
                                    </td>
                                    <td class="text-nowrap">{{ data.TotalTonnage }}</td>
                                    <td class="text-nowrap">{{ data.UnitPrice }}</td>
                                    <td class="text-nowrap">{{ data.TotalPrice }}</td>
                                </tr>
                        </template>
                    </tbody>
                </table>
        </div>
        <div class="row">
            <h2>Seferler</h2>
            <div class="row mt-2 table-responsive">
                <table class="table table-sm table-bordered align-middle" >
                    <thead>
                        <tr>
                            <th v-if="IrsaliyeGroup.Status != 6" class="text-nowrap">İşlemler</th>
                            <th  v-if="IrsaliyeGroup.Status == 8 && IrsaliyeGroup.Status != 9" title="Değişiklik Talep Durumu" class="text-nowrap">Değ. Talep Durumu</th>
                            <th  class="text-nowrap">İrsaliye No</th>
                            <th  class="text-nowrap">Tarih</th>
                            <th  class="text-nowrap">Başlangıç Bölge</th>
                            <th  class="text-nowrap">Taşınan Firma Adı</th>
                            <th  v-if="IrsaliyeGroup.Status ==  1" class="text-nowrap">Düzenlenen Taşınan Firma Adı</th>
                            <th  class="text-nowrap">Bitiş Bölge</th>
                            <th  class="text-nowrap">Araç Tipi</th>
                            <th  class="text-nowrap">Plaka</th>
                            <th  class="text-nowrap">Ürün Tipi</th>
                            <th  class="text-nowrap">Ton</th>
                            <!-- Sayac tonu — kullanicinin girdigi, henuz kaydedilmemis yerel deger ile
                                 onaylanmis ChangeRequests degerini tek hucrede birlestirir. -->
                            <th v-if="showCounterColumns" class="text-nowrap">Sayac Tonu</th>
                            <th v-if="showCounterColumns" class="text-nowrap text-right">Fark</th>
                            <th v-if="showPriceColumn" class="text-nowrap">Fiyat</th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="(data, ind) in $safe(IrsaliyeGroup,'IrsaliyeSefers')">
                            <tr :key="ind">
                                <td v-if="IrsaliyeGroup.Status !=  6" class="text-nowrap">
                                    
                                    <b-dropdown v-if="(IrsaliyeGroup.Status == 1 ||( IrsaliyeGroup.Status ==  8 && data.IsChangeRequestHas))" dropright size="sm" variant="light" no-caret>
                                        <template #button-content>
                                            <feather-icon class="mr-50" icon="MoreHorizontalIcon"></feather-icon>
                                            İşlemler
                                        </template>
                                        <b-dropdown-item  variant="primary" v-if="IrsaliyeGroup.IsCounterTonnage && IrsaliyeGroup.Status ==  1" v-on:click="openTonnageEditModal(data)">
                                                <feather-icon class="mr-50" icon="ChevronsRightIcon" size="16"></feather-icon>
                                                Tonaj Bilgisi Düzenle
                                        </b-dropdown-item>
                                        <b-dropdown-item v-if="IrsaliyeGroup.Status ==  1"  variant="success" v-on:click="openEditBitisFirmNameModal(data)">
                                                <feather-icon class="mr-50" icon="LayoutIcon" size="16"></feather-icon>
                                                Taşınan Firma Bilgisini Düzenle
                                        </b-dropdown-item>
                                        <b-dropdown-item v-if="IrsaliyeGroup.Status ==  8" variant="primary"  v-on:click="getChangeRequestDetail(data)">
                                                <feather-icon class="mr-50" icon="InfoIcon" size="16" ></feather-icon>
                                                Değişiklik Talebini Görüntüle
                                        </b-dropdown-item> 
                                    </b-dropdown>
                                    
                                </td>
                                <td v-if="IrsaliyeGroup.Status !=  6 && IrsaliyeGroup.Status ==  8">
                                    <div class="text-center">
                                            <span v-if="$safe(data,'IsChangeRequestHas') == true" class="material-icons-outlined text-success">check_circle</span>
                                            <span v-else class="material-icons-outlined text-danger">cancel</span>
                                    </div>
                                </td>
                                <td class="text-nowrap">{{ $safe(data,'IrsaliyeNo') }}</td>
                                <td class="text-nowrap">{{ data.Gun }}</td>
                                <td class="text-nowrap">{{ $safe(data,'BaslangicRegion') }}</td>
                                <td class="text-nowrap">{{ $safe(data,'BitisFirmaAdi') }}</td>
                                <td  v-if="IrsaliyeGroup.Status ==  1" class="text-nowrap">
                                    <b-badge  variant="success">{{ $safe(data,'FixedFirmaAdi') }}</b-badge>
                                    
                                </td>
                                <td class="text-nowrap">{{ $safe(data,'BitisRegion') }}</td>
                                <td class="text-nowrap">{{ $safe(data,'VehicleTypeName') }}</td>
                                <td class="text-nowrap">{{ $safe(data,'TasiyiciAracPlaka') }}</td>
                                <td class="text-nowrap">{{ $safe(data,'TasinanUrunAdi') }}</td>
                                <td class="text-nowrap">{{ $safe(data,'TasinanUrunMiktariStr') }}</td>
                                <!-- Sayac tonu:
                                     - Ekranda kullanici girdiyse yerel deger,
                                     - Onay gonderilmisse ChangeRequests.CounterTonnage,
                                     - Ikisi de yoksa "-".
                                     Durum rozeti onaylanmis/bekleyen/reddedilen ayrimini gosterir. -->
                                <td v-if="showCounterColumns" class="text-nowrap">
                                    <span v-if="counterTonnageRows[ind] && counterTonnageRows[ind].effective != null">
                                        <b-badge variant="primary">{{ counterTonnageRows[ind].effective }}</b-badge>
                                        <b-badge v-if="counterTonnageRows[ind].local != null && counterTonnageRows[ind].local !== ''"
                                                 variant="light-warning" class="ml-25" title="Henuz Onaylanmadi">taslak</b-badge>
                                        <b-badge v-else-if="counterTonnageRows[ind].statusValue === 0" variant="light-warning" class="ml-25">Bekliyor</b-badge>
                                        <b-badge v-else-if="counterTonnageRows[ind].statusValue === 1" variant="light-success" class="ml-25">Onaylandi</b-badge>
                                        <b-badge v-else-if="counterTonnageRows[ind].statusValue === 2" variant="light-danger" class="ml-25">Reddedildi</b-badge>
                                    </span>
                                    <span v-else class="text-muted">-</span>
                                </td>
                                <td v-if="showCounterColumns" class="text-nowrap text-right">
                                    <span v-if="counterTonnageRows[ind] && counterTonnageRows[ind].diff != null"
                                          :class="counterTonnageRows[ind].diff > 0 ? 'text-success' : counterTonnageRows[ind].diff < 0 ? 'text-danger' : ''">
                                        {{ counterTonnageRows[ind].diff > 0 ? '+' : '' }}{{ counterTonnageRows[ind].diff }}
                                    </span>
                                    <span v-else class="text-muted">-</span>
                                </td>
                                <td v-if="showPriceColumn" class="text-nowrap text-right">
                                    <b-badge variant="danger">{{ $safe(data,'PriceStr') +' ₺'}} </b-badge>
                                </td>
                            </tr>
                        </template>
                    </tbody>
                    <tfoot class="font-weight-bolder table-secondary">
                        <tr>
                            <td :colspan="columnsBeforeTon" class="text-right">
                                Toplam ({{ totals.seferCount }} sefer)
                            </td>
                            <td class="text-nowrap">{{ totals.totalTon }}</td>
                            <td v-if="showCounterColumns" class="text-nowrap">
                                <span v-if="totals.totalCounterKnownCount > 0">{{ totals.totalCounter }}</span>
                                <span v-else class="text-muted">-</span>
                            </td>
                            <td v-if="showCounterColumns" class="text-nowrap text-right"
                                :class="totals.totalDiff > 0 ? 'text-success' : totals.totalDiff < 0 ? 'text-danger' : ''">
                                <template v-if="totals.totalCounterKnownCount > 0">
                                    {{ totals.totalDiff > 0 ? '+' : '' }}{{ totals.totalDiff }}
                                </template>
                                <span v-else class="text-muted">-</span>
                            </td>
                            <td v-if="showPriceColumn" class="text-nowrap text-right">
                                <b-badge variant="danger">{{ totals.totalPrice.toLocaleString('tr-TR', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }} ₺</b-badge>
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>

        <!-- Basit kirilim: Varis Noktasi x Urun. Fiyat asamasinda toplam tutar
             kolonu da otomatik cikar. Frontend'de hesaplanir, tonaj duzeltince canli. -->
        <div v-if="breakdownRows.length" class="row mt-2">
            <div class="col-12">
                <h4>Ozet (Varis Noktasi × Urun)</h4>
                <div class="table-responsive">
                    <table class="table table-sm table-bordered align-middle mb-0">
                        <thead>
                            <tr>
                                <th>Varis Noktasi</th>
                                <th>Urun</th>
                                <th class="text-right">Sefer</th>
                                <th class="text-right">Toplam Ton</th>
                                <th v-if="showCounterColumns" class="text-right">Sayac Ton</th>
                                <th v-if="showCounterColumns" class="text-right">Fark</th>
                                <th v-if="showPriceColumn" class="text-right">Toplam Tutar</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(g, i) in breakdownRows" :key="i">
                                <td class="text-nowrap">{{ g.destination }}</td>
                                <td class="text-nowrap">{{ g.material }}</td>
                                <td class="text-right">{{ g.seferCount }}</td>
                                <td class="text-right">{{ g.totalTon }}</td>
                                <td v-if="showCounterColumns" class="text-right">
                                    <span v-if="g.totalCounterKnown > 0">{{ g.totalCounter }}</span>
                                    <span v-else class="text-muted">-</span>
                                </td>
                                <td v-if="showCounterColumns" class="text-right"
                                    :class="g.totalDiff > 0 ? 'text-success' : g.totalDiff < 0 ? 'text-danger' : ''">
                                    <template v-if="g.totalCounterKnown > 0">
                                        {{ g.totalDiff > 0 ? '+' : '' }}{{ g.totalDiff }}
                                    </template>
                                    <span v-else class="text-muted">-</span>
                                </td>
                                <td v-if="showPriceColumn" class="text-right">
                                    <span v-if="g.hasPrice">{{ g.totalPrice.toLocaleString('tr-TR', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }} ₺</span>
                                    <span v-else class="text-muted">-</span>
                                </td>
                            </tr>
                        </tbody>
                        <tfoot class="font-weight-bolder table-secondary">
                            <tr>
                                <td colspan="2" class="text-right">GENEL TOPLAM</td>
                                <td class="text-right">{{ totals.seferCount }}</td>
                                <td class="text-right">{{ totals.totalTon }}</td>
                                <td v-if="showCounterColumns" class="text-right">
                                    <span v-if="totals.totalCounterKnownCount > 0">{{ totals.totalCounter }}</span>
                                    <span v-else class="text-muted">-</span>
                                </td>
                                <td v-if="showCounterColumns" class="text-right"
                                    :class="totals.totalDiff > 0 ? 'text-success' : totals.totalDiff < 0 ? 'text-danger' : ''">
                                    <template v-if="totals.totalCounterKnownCount > 0">
                                        {{ totals.totalDiff > 0 ? '+' : '' }}{{ totals.totalDiff }}
                                    </template>
                                    <span v-else class="text-muted">-</span>
                                </td>
                                <td v-if="showPriceColumn" class="text-right">
                                    {{ totals.totalPrice.toLocaleString('tr-TR', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }} ₺
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        </div>
        <div class="row justify-content-end">
            <div v-if="IrsaliyeGroup.Status ==  1" class="col-auto mb-1 mb-md-0">
                <v-executer :loading="sendIrsaliyeLoading" :action="sendIrsaliyeGroupToControl">Onayla</v-executer>
            </div>
            
        </div>
    </b-card>
</template>

<script>
import { BBadge, BCard,BFormCheckbox,BDropdown,BDropdownItem,BSpinner } from 'bootstrap-vue'
import { IrsaliyeOperationsApi } from '@/api/irsaliye'
import VStatsBox from '@/components/VStatsBox.vue'
import CounterTonnageEdit from './components/CounterTonnageEdit.vue'
import BitisFirmEdit from './components/BitisFirmEdit.vue'
import IrsaliyeSeferExtraRouteAdd from './components/IrsaliyeSeferExtraRouteAdd.vue'
import ChangeRequestDetailView from './components/ChangeRequestDetailView.vue'

export default {
    components:{
        ChangeRequestDetailView,
        IrsaliyeSeferExtraRouteAdd,
        BDropdown,
        BDropdownItem,
        BitisFirmEdit,
        CounterTonnageEdit,
        BCard,
        BBadge,
        VStatsBox,
        BFormCheckbox,
        BSpinner
    },
    data(){
        return{
            detailLoading: false,
            printLoading:false,
            IrsaliyeGroupDetailStats:[],
            EditTonnage:{
                Id:null,
                Tonnage:null,
                IrsaliyeNo:null
            },
            EditIrsaliyeSeferBitisFirm:{
                Id:null,
                FirmName:null,
                IrsaliyeNo:null
            },
            counterTonnageLoading:false,
            IrsaliyeGroup:{
                Id:null,
                CarrierCariName:null,
                CarrierCariCode:null,
                ReferenceNo:null,
                CreateTime:null,
                StartDate:null,
                EndDate:null,
                IrsaliyeSefers:[],
                Status:null,
                StatusStr:null,
                IsCounterTonnage:null
            },
            IrsaliyeSeferExtraRoute:{
                VehicleTransportStatus:0,
                ParentIrsaliyeGroupSeferId:null,
                ParentIrsaliyeNo:null,
                BitisFirmaAdi:null,
                IrsaliyeNo:null,
                Tonnage:null,
                RegionId:null,
                TasinanUrunAdi:null,
                TasiyiciAracPlaka:null,
                TasiyiciAracDorsePlaka:null,
                Gun:null,
                StockCode:null

            },
            ChangeRequestDetail:{
                IrsaliyeNo:null,
                CounterTonnageRequestId:null,
                CounterTonnage:null,
                FixedFirmNameId:null,
                FixedFirmName:null,
                ExtraRouteId:null,
                ExtraRoute:{
                    BitisFirmaAdi:null,
                    IrsaliyeNo:null,
                    Tonnage:null,
                    VehicleTransportStatus:null,
                    RegionId:null,
                    TasinanUrunAdi:null,
                    TasiyiciAracPlaka:null,
                    TasiyiciAracDorsePlaka:null,
                    Gun:null,
                    StockCode:null,
                    StockName:null
                },
                CounterTonnageStatus:null,
                CounterTonnageStatusValue:null,
                FixedFirmNameStatus:null,
                FixedFirmNameStatusValue:null,
                ExtraRouteStatus:null,
                ExtraRouteStatusValue:null
            },
            sendIrsaliyeLoading:false
        }
    },
    mounted(){
        this.getDetail()
    },
    computed:{
        // Yazdirilabilir olsun ya da olmasin, sayac tonaji her satirda tek noktadan
        // okunmalidir. Ekranda kullanici o an duzenliyorsa yerel CounterTonnage dolu; onay
        // gonderildikten sonra sunucu bunu ChangeRequests.CounterTonnage olarak dondurur.
        // "Onay gonderilmis mi" bilgisi durum rozeti icin ChangeRequestCounterTonnage'dan
        // gelir; yerel duzenlemenin heniz kaydedilmedigi belli olsun.
        counterTonnageRows(){
            return (this.IrsaliyeGroup.IrsaliyeSefers || []).map(row => {
                const local = row.CounterTonnage
                const cr = row.ChangeRequests || {}
                const remote = cr.CounterTonnage != null && cr.CounterTonnage !== ''
                    ? Number(String(cr.CounterTonnage).replace(',', '.'))
                    : null
                const effective = (local != null && local !== '' && !isNaN(local))
                    ? Number(local)
                    : remote

                const irsaliye = Number(row.TasinanUrunMiktari) || 0
                const diff = effective != null ? +(effective - irsaliye).toFixed(3) : null

                return { row, local, remote, effective, irsaliye, diff, status: cr.CounterTonnageStatus, statusValue: cr.CounterTonnageStatusValue }
            })
        },
        // Toplam satiri: sefer sayisi, toplam ton, (sayac aciksa) sayac ton toplami + fark,
        // (fiyat asamasiysa) toplam tutar. Frontend'de hesaplanir — kullanici tonaj duzeltince
        // canli guncellensin diye.
        totals(){
            const rows = this.counterTonnageRows
            const seferCount = rows.length
            const totalTon = rows.reduce((a, r) => a + (r.irsaliye || 0), 0)
            const totalCounterKnown = rows.filter(r => r.effective != null)
            const totalCounter = totalCounterKnown.reduce((a, r) => a + r.effective, 0)
            const totalDiff = totalCounterKnown.reduce((a, r) => a + (r.diff || 0), 0)
            const priceRows = (this.IrsaliyeGroup.IrsaliyeSefers || []).filter(r => r.Price != null)
            const totalPrice = priceRows.reduce((a, r) => a + Number(r.Price || 0), 0)
            return {
                seferCount,
                totalTon: +totalTon.toFixed(3),
                totalCounter: +totalCounter.toFixed(3),
                totalCounterKnownCount: totalCounterKnown.length,
                totalDiff: +totalDiff.toFixed(3),
                totalPrice: +totalPrice.toFixed(2)
            }
        },
        // Basit kirilim: Varis Noktasi (BitisFirmaAdi) x Urun. Nakliyeci "nereye ne kadar
        // tasidim" cevabini bulur. Detayli 5'li kirilimi (araç tipi, birim fiyat) fiyat
        // asamasindaki mevcut ozet tablosuna birakiyoruz.
        breakdownRows(){
            const map = new Map()
            for(const r of this.counterTonnageRows){
                const key = (r.row.BitisFirmaAdi || '-') + '||' + (r.row.TasinanUrunAdi || '-')
                let g = map.get(key)
                if(!g){
                    g = {
                        destination: r.row.BitisFirmaAdi || '-',
                        material: r.row.TasinanUrunAdi || '-',
                        seferCount: 0,
                        totalTon: 0,
                        totalCounter: 0,
                        totalCounterKnown: 0,
                        totalDiff: 0,
                        totalPrice: 0,
                        hasPrice: false
                    }
                    map.set(key, g)
                }
                g.seferCount++
                g.totalTon += r.irsaliye || 0
                if(r.effective != null){
                    g.totalCounter += r.effective
                    g.totalCounterKnown++
                    g.totalDiff += r.diff || 0
                }
                if(r.row.Price != null){
                    g.totalPrice += Number(r.row.Price)
                    g.hasPrice = true
                }
            }
            return Array.from(map.values())
                .sort((a, b) => a.destination.localeCompare(b.destination, 'tr') || a.material.localeCompare(b.material, 'tr'))
                .map(g => ({
                    ...g,
                    totalTon: +g.totalTon.toFixed(3),
                    totalCounter: +g.totalCounter.toFixed(3),
                    totalDiff: +g.totalDiff.toFixed(3),
                    totalPrice: +g.totalPrice.toFixed(2)
                }))
        },
        // Sayac tonaji fark alanini gostermeli miyiz? Sayac uygulaniyor ve tonaj eksik
        // olmayan en az bir kayit var demek. Ekranin altindaki toplam ozeti de bu kurala uyar.
        showCounterColumns(){
            return this.IrsaliyeGroup.IsCounterTonnage === true
        },
        // Fiyat asamasi (fiyatlar hesaplanmis, muhasebe onayindan sonrasi) — mevcut kural.
        showPriceColumn(){
            return this.IrsaliyeGroup.Status == 9 || this.IrsaliyeGroup.Status == 6
        },
        // Ekran taslak modunda mi? Kullanici tonaj duzeltiyor, henuz "Onayla" demedi.
        isDraft(){
            return this.IrsaliyeGroup.Status == 1
        },
        // Ozet fiyat tablosu (mevcut) fiyat asamasinda gorunur.
        showFiyatOzet(){
            return this.IrsaliyeGroupDetailStats.length > 0 &&
                (this.IrsaliyeGroup.Status == 9 || this.IrsaliyeGroup.Status == 10 || this.IrsaliyeGroup.Status == 11)
        },
        // Sefer tablosunda "Ton" kolonundan onceki toplam kolon sayisi. Status'e gore
        // İşlemler / Değ.Talep / Duzenlenen Tasinan Firma Adi kolonlari acilip kapaniyor;
        // tfoot toplam satirinin colspan'i buna gore hesaplanir.
        columnsBeforeTon(){
            let n = 9 // Irsaliye No + Tarih + Bas. Bolge + Tas. Firma + Bitis + Arac + Plaka + Urun + (Ton yok)
            const st = this.IrsaliyeGroup.Status
            if(st != 6) n++              // Islemler
            if(st == 8 && st != 9) n++    // Deg. Talep Durumu
            if(st == 1) n++              // Duzenlenen Tasinan Firma Adi
            return n
        },
        printDate(){
            const d = new Date()
            const pad = n => String(n).padStart(2, '0')
            return pad(d.getDate()) + '.' + pad(d.getMonth() + 1) + '.' + d.getFullYear() +
                ' ' + pad(d.getHours()) + ':' + pad(d.getMinutes())
        }
    },
    methods:{
        // ---------- Tonaj kaynağı rozeti (Task 3, nakliyeci ekranı) ----------
        // Backend her stats satırında SeferCount + CounterTonnageSeferCount döndürüyor;
        // ordan sınıflandırıyoruz. Nakliyeci ekranında sadece rozet gösteriliyor,
        // iç ekran (WaybillGroupDetailView) ayrıca fark ve tooltip veriyor.
        tonnageBadge(data){
            const total = data?.SeferCount || 0
            const counter = data?.CounterTonnageSeferCount || 0
            if(total === 0)         return { label: '-',      variant: 'light' }
            if(counter === 0)       return { label: 'VİŞNE',  variant: 'light-secondary' }
            if(counter === total)   return { label: 'KARŞI',  variant: 'light-primary'   }
            return { label: `KARIŞIK (${counter}/${total})`, variant: 'light-warning' }
        },
        clearSeferExtraRoute(){
            this.IrsaliyeSeferExtraRoute.ParentIrsaliyeNo = null
            this.IrsaliyeSeferExtraRoute.VehicleTransportStatus = 0
            this.IrsaliyeSeferExtraRoute.ParentIrsaliyeGroupSeferId = null
            this.IrsaliyeSeferExtraRoute.BitisFirmaAdi = null
            this.IrsaliyeSeferExtraRoute.IrsaliyeNo = null
            this.IrsaliyeSeferExtraRoute.Tonnage = null
            this.IrsaliyeSeferExtraRoute.RegionId = null
            this.IrsaliyeSeferExtraRoute.TasinanUrunAdi = null
            this.IrsaliyeSeferExtraRoute.TasiyiciAracPlaka = null
            this.IrsaliyeSeferExtraRoute.TasiyiciAracDorsePlaka = null
            this.IrsaliyeSeferExtraRoute.Gun = null
            this.IrsaliyeSeferExtraRoute.StockCode = null
            this.IrsaliyeSeferExtraRoute.StockName = null
        },
        getChangeRequestDetail(data){
            this.ChangeRequestDetail.IrsaliyeNo = data.IrsaliyeNo
            this.ChangeRequestDetail.CounterTonnageRequestId = data.ChangeRequests.CounterTonnageRequestId
            this.ChangeRequestDetail.CounterTonnage = data.ChangeRequests.CounterTonnage
            this.ChangeRequestDetail.FixedFirmNameId = data.ChangeRequests.FixedFirmNameId
            this.ChangeRequestDetail.FixedFirmName = data.ChangeRequests.FixedFirmName
            this.ChangeRequestDetail.ExtraRouteId = data.ChangeRequests.ExtraRouteId
            this.ChangeRequestDetail.CounterTonnageStatus = data.ChangeRequests.CounterTonnageStatus
            this.ChangeRequestDetail.CounterTonnageStatusValue = data.ChangeRequests.CounterTonnageStatusValue
            this.ChangeRequestDetail.FixedFirmNameStatus = data.ChangeRequests.FixedFirmNameStatus
            this.ChangeRequestDetail.FixedFirmNameStatusValue = data.ChangeRequests.FixedFirmNameStatusValue
            this.ChangeRequestDetail.ExtraRouteStatus = data.ChangeRequests.ExtraRouteStatus
            this.ChangeRequestDetail.ExtraRouteStatusValue = data.ChangeRequests.ExtraRouteStatusValue
            this.ChangeRequestDetail.ExtraRoute.BitisFirmaAdi = data.ChangeRequests.ExtraRoute?.BitisFirmaAdi
            this.ChangeRequestDetail.ExtraRoute.Tonnage = data.ChangeRequests.ExtraRoute?.Tonnage
            this.ChangeRequestDetail.ExtraRoute.IrsaliyeNo = data.ChangeRequests.ExtraRoute?.IrsaliyeNo
            this.ChangeRequestDetail.ExtraRoute.VehicleTransportStatus = data.ChangeRequests.ExtraRoute?.VehicleTransportStatus
            this.ChangeRequestDetail.ExtraRoute.Gun = data.ChangeRequests.ExtraRoute?.Gun
            this.ChangeRequestDetail.ExtraRoute.RegionName = data.ChangeRequests.ExtraRoute?.RegionName
            this.ChangeRequestDetail.ExtraRoute.StockCode = data.ChangeRequests.ExtraRoute?.StockCode
            this.ChangeRequestDetail.ExtraRoute.StockName = data.ChangeRequests.ExtraRoute?.StockName
            this.ChangeRequestDetail.ExtraRoute.TasiyiciAracDorsePlaka = data.ChangeRequests.ExtraRoute?.TasiyiciAracDorsePlaka
            this.ChangeRequestDetail.ExtraRoute.TasiyiciAracPlaka = data.ChangeRequests.ExtraRoute?.TasiyiciAracPlaka
            this.$showModal('change-request-detail')
        },
        clearEditTonnage(){
            this.EditTonnage.Id=null
            this.EditTonnage.Tonnage=null
            this.EditTonnage.IrsaliyeNo = null
        },
        clearEditBitisFirmName(){
            this.EditIrsaliyeSeferBitisFirm.Id = null
            this.EditIrsaliyeSeferBitisFirm.FirmName = null
        },
        deleteSeferExtraRouteModal(id){
            let irsaliyeSefer = this.IrsaliyeGroup.IrsaliyeSefers.filter(c=> c.Id == id)[0];
            if(irsaliyeSefer.IrsaliyeSeferExtraRoute.ParentIrsaliyeGroupSeferId != null){
                this.$confirm('İlgili İrsaliyeye Ait Ek Rota Silinecektir',`Bu işlem ${irsaliyeSefer.IrsaliyeSeferExtraRoute.ParentIrsaliyeNo} irsaliyesine ait olan ek rotayı silecektir. Onaylıyor musunuz?`).then(result=>{
                if(result){
                    irsaliyeSefer.IrsaliyeSeferExtraRoute.ParentIrsaliyeNo = null
                    irsaliyeSefer.IrsaliyeSeferExtraRoute.ParentIrsaliyeGroupSeferId = null
                    irsaliyeSefer.IrsaliyeSeferExtraRoute.VehicleTransportStatus = 0
                    irsaliyeSefer.IrsaliyeSeferExtraRoute.BitisFirmaAdi = null
                    irsaliyeSefer.IrsaliyeSeferExtraRoute.IrsaliyeNo = null
                    irsaliyeSefer.IrsaliyeSeferExtraRoute.Tonnage = null
                    irsaliyeSefer.IrsaliyeSeferExtraRoute.RegionId = null
                    irsaliyeSefer.IrsaliyeSeferExtraRoute.TasinanUrunAdi = null
                    irsaliyeSefer.IrsaliyeSeferExtraRoute.TasiyiciAracPlaka = null
                    irsaliyeSefer.IrsaliyeSeferExtraRoute.TasiyiciAracDorsePlaka = null
                    irsaliyeSefer.IrsaliyeSeferExtraRoute.Gun = null
                    irsaliyeSefer.IrsaliyeSeferExtraRoute.StockCode = null
                    irsaliyeSefer.IrsaliyeSeferExtraRoute.StockName = null
                }
            })
            }
        },
        editSeferExtraRoute(){
            this.IrsaliyeGroup.IrsaliyeSefers.map(c=> {
                if(c.Id==this.IrsaliyeSeferExtraRoute.ParentIrsaliyeGroupSeferId){
                    c.IrsaliyeSeferExtraRoute.ParentIrsaliyeNo = this.IrsaliyeSeferExtraRoute.ParentIrsaliyeNo
                    c.IrsaliyeSeferExtraRoute.ParentIrsaliyeGroupSeferId = this.IrsaliyeSeferExtraRoute.ParentIrsaliyeGroupSeferId 
                    c.IrsaliyeSeferExtraRoute.VehicleTransportStatus = this.IrsaliyeSeferExtraRoute.VehicleTransportStatus 
                    c.IrsaliyeSeferExtraRoute.BitisFirmaAdi = this.IrsaliyeSeferExtraRoute.BitisFirmaAdi 
                    c.IrsaliyeSeferExtraRoute.IrsaliyeNo = this.IrsaliyeSeferExtraRoute.IrsaliyeNo 
                    c.IrsaliyeSeferExtraRoute.Tonnage = this.IrsaliyeSeferExtraRoute.Tonnage 
                    c.IrsaliyeSeferExtraRoute.RegionId = this.IrsaliyeSeferExtraRoute.RegionId 
                    c.IrsaliyeSeferExtraRoute.TasinanUrunAdi = this.IrsaliyeSeferExtraRoute.TasinanUrunAdi
                    c.IrsaliyeSeferExtraRoute.TasiyiciAracPlaka = this.IrsaliyeSeferExtraRoute.TasiyiciAracPlaka
                    c.IrsaliyeSeferExtraRoute.TasiyiciAracDorsePlaka = this.IrsaliyeSeferExtraRoute.TasiyiciAracDorsePlaka
                    c.IrsaliyeSeferExtraRoute.Gun = this.IrsaliyeSeferExtraRoute.Gun
                    c.IrsaliyeSeferExtraRoute.StockCode =  this.IrsaliyeSeferExtraRoute.StockCode
                    c.IrsaliyeSeferExtraRoute.StockName =  this.IrsaliyeSeferExtraRoute.StockName
                }
                return c
            })
            this.$hideModal('irsaliye-sefer-extra-route-add')
        },
        
        openEditSeferExtraRouteModal(data){
            this.clearSeferExtraRoute()
            this.IrsaliyeSeferExtraRoute.ParentIrsaliyeNo = data.IrsaliyeNo
            this.IrsaliyeSeferExtraRoute.ParentIrsaliyeGroupSeferId = data.Id
            this.IrsaliyeSeferExtraRoute.VehicleTransportStatus = data.IrsaliyeSeferExtraRoute.VehicleTransportStatus
            this.IrsaliyeSeferExtraRoute.BitisFirmaAdi = data.IrsaliyeSeferExtraRoute.BitisFirmaAdi
            this.IrsaliyeSeferExtraRoute.IrsaliyeNo = data.IrsaliyeSeferExtraRoute.IrsaliyeNo
            this.IrsaliyeSeferExtraRoute.Tonnage = data.IrsaliyeSeferExtraRoute.Tonnage
            this.IrsaliyeSeferExtraRoute.RegionId = data.IrsaliyeSeferExtraRoute.RegionId
            this.IrsaliyeSeferExtraRoute.TasinanUrunAdi = data.IrsaliyeSeferExtraRoute.TasinanUrunAdi
            this.IrsaliyeSeferExtraRoute.TasiyiciAracPlaka = data.IrsaliyeSeferExtraRoute.TasiyiciAracPlaka
            this.IrsaliyeSeferExtraRoute.TasiyiciAracDorsePlaka = data.IrsaliyeSeferExtraRoute.TasiyiciAracDorsePlaka
            this.IrsaliyeSeferExtraRoute.Gun = data.IrsaliyeSeferExtraRoute.Gun
            this.IrsaliyeSeferExtraRoute.StockCode =  data.IrsaliyeSeferExtraRoute.StockCode
            this.IrsaliyeSeferExtraRoute.StockName =  data.IrsaliyeSeferExtraRoute.StockName

            this.$showModal('irsaliye-sefer-extra-route-add')
        },
        editTonnage(){
            this.IrsaliyeGroup.IrsaliyeSefers.map(c=> {
                if(c.Id==this.EditTonnage.Id){
                    c.CounterTonnage = this.EditTonnage.Tonnage
                }
                return c
            })
            this.$hideModal('tonnage-edit')
            
        },
        editBitisFirm(){
            this.IrsaliyeGroup.IrsaliyeSefers.map(c=> {
                if(c.Id==this.EditIrsaliyeSeferBitisFirm.Id){
                    c.FixedFirmaAdi = this.EditIrsaliyeSeferBitisFirm.FirmName
                }
                return c
            })
            this.$hideModal('bitis-firm-edit')
            
        },
        
        openEditBitisFirmNameModal(data){
            this.clearEditBitisFirmName()
            this.EditIrsaliyeSeferBitisFirm.Id = data.Id
            this.EditIrsaliyeSeferBitisFirm.IrsaliyeNo = data.IrsaliyeNo
            this.$showModal('bitis-firm-edit')
        },
        openTonnageEditModal(data){
            this.clearEditTonnage()
            this.EditTonnage.Id = data.Id
            this.EditTonnage.IrsaliyeNo=data.IrsaliyeNo
            this.$showModal('tonnage-edit')
        },
        getDetail(){
            this.detailLoading = true
            const id = this.$route.params.id || null
            const code = this.$route.query.code || null
            if(id && code){
                IrsaliyeOperationsApi.CustomerDetail(code).then(res => {
                    if(!res.data.Success)
                        this.$result(res)
                    else{
                        this.IrsaliyeGroup.Id=res.data.Data.Id
                        this.IrsaliyeGroup.IrsaliyeNo = res.data.Data.IrsaliyeNo
                        this.IrsaliyeGroup.CarrierCariName = res.data.Data.CarrierCariName
                        this.IrsaliyeGroup.CarrierCariCode = res.data.Data.CarrierCariCode
                        this.IrsaliyeGroup.ReferenceNo = res.data.Data.ReferenceNo
                        this.IrsaliyeGroup.CreateTime = res.data.Data.CreateTime
                        this.IrsaliyeGroup.StartDate = res.data.Data.StartDate
                        this.IrsaliyeGroup.EndDate = res.data.Data.EndDate
                        this.IrsaliyeGroup.Status = res.data.Data.Status
                        this.IrsaliyeGroup.StatusStr = res.data.Data.StatusStr
                        this.IrsaliyeGroup.IsCounterTonnage = res.data.Data.IsCounterTonnage
                        this.IrsaliyeGroup.IrsaliyeSefers = res.data.Data.IrsaliyeSefers
                        this.IrsaliyeGroup.IrsaliyeSefers = this.IrsaliyeGroup.IrsaliyeSefers.map(f => {
                            return {
                                ...f,
                                CounterTonnage:null,
                                FixedFirmaAdi:null,
                                IrsaliyeSeferExtraRoute:{
                                    ParentIrsaliyeNo:null,
                                    VehicleTransportStatus:0,
                                    ParentIrsaliyeGroupSeferId:null,
                                    BitisFirmaAdi:null,
                                    IrsaliyeNo:null,
                                    Tonnage:null,
                                    RegionId:null,
                                    TasinanUrunAdi:null,
                                    TasiyiciAracPlaka:null,
                                    TasiyiciAracDorsePlaka:null,
                                    Gun:null,
                                    StockCode:null,
                                    StockName:null
    
                                }
                            }
                        })
                        IrsaliyeOperationsApi.DetailStats(res.data.Data.Id).then(res => {
                            if(!res.data.Success)
                                this.$result(res)
                            else{
                                this.IrsaliyeGroupDetailStats = res.data.Data
                            }
                        }).catch(err => {
                            console.error(err);
                        })
                    }
                }).catch(err => {
                    console.error(err);
                }).finally(() => { this.detailLoading = false })
            }
        },
        // Sunucu tarafinda PDF uretimi. Ekrandaki taslak sayac tonaj degerleri
        // Overrides listesi ile POST edilir; nakliyeci "Onayla"ya basmadan yazdirsa bile
        // kaydedilmemis degisiklikler PDF'te goriunur. Butun tabloyu yatay A4'te sigdirdigi
        // icin eski window.print() akisi devreden cikti.
        printPage(){
            const code = this.$route.query.code
            if(!code){
                this.$alert && this.$alert("Erişim kodu bulunamadı.", "error", "danger")
                return
            }

            const overrides = (this.IrsaliyeGroup.IrsaliyeSefers || [])
                .filter(s => s.CounterTonnage != null && s.CounterTonnage !== "" && Number(s.CounterTonnage) !== 0)
                .map(s => ({ Id: s.Id, CounterTonnage: Number(String(s.CounterTonnage).replace(",", ".")) }))

            this.printLoading = true
            IrsaliyeOperationsApi.MutabakatPdf({ Code: code, Overrides: overrides })
                .then(res => {
                    // Blob geldi mi kontrol et: hata durumunda application/json donebilir.
                    const type = res.headers && (res.headers["content-type"] || res.headers.get?.("content-type"))
                    if(type && type.indexOf("application/pdf") < 0){
                        // Hata JSON'unu okuyup goster
                        const reader = new FileReader()
                        reader.onload = () => {
                            try{
                                const err = JSON.parse(reader.result)
                                this.$alert && this.$alert(err.Message || "PDF oluşturulamadı.", "error", "danger")
                            }catch(e){
                                this.$alert && this.$alert("PDF oluşturulamadı.", "error", "danger")
                            }
                        }
                        reader.readAsText(res.data)
                        return
                    }
                    const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }))
                    const a = document.createElement("a")
                    a.href = url
                    a.download = "Mutabakat-" + (this.IrsaliyeGroup.ReferenceNo || "belge") + ".pdf"
                    document.body.appendChild(a)
                    a.click()
                    a.remove()
                    window.URL.revokeObjectURL(url)
                })
                .catch(err => {
                    this.$result && this.$result(null, err)
                })
                .finally(() => {
                    this.printLoading = false
                })
        },
        sendIrsaliyeGroupToControl(){
            this.sendIrsaliyeLoading=true
            this.$confirm('İlgili İrsaliye Grubu Muhasebe Departmanına Onay İçin Gönderilecektir. Onaylıyor Musunuz?',
                            `Bu işlem ${this.IrsaliyeGroup.ReferenceNo} adlı irsaliye grubunu muhasebe departmanına onay için gönderecektir.`).then(result=>{
                if(result){
                    IrsaliyeOperationsApi.SendIrsaliyeGroupToControl(this.IrsaliyeGroup).then(res => {
                        this.sendIrsaliyeLoading=false
                        this.$result(res)
                        if(res.data.Success){
                            this.getDetail()
                        }
                    }).then(err=>{
                        this.sendIrsaliyeLoading=false
                    })
                }
            })
        }
    }
}
</script>

<style>
/* Yazdirilabilir cikti icin kurallar. Ekran gorunumu hi bir sekilde etkilenmez;
   tum kurallar @media print icinde. */
@media print {
    @page {
        size: landscape;
        margin: 10mm;
    }

    /* Ekrana ozgu ogeleri gizle: dropdown butonlari, onay butonu, modaller, action kolonu. */
    .no-print,
    .b-dropdown,
    .modal,
    button.btn-primary,
    button.btn-outline-primary,
    .v-executer,
    .card-header {
        display: none !important;
    }

    /* Kart cercevesini ve golgesini kaldir — yazdirmada gereksiz. */
    .card,
    .card-body {
        border: 0 !important;
        box-shadow: none !important;
        padding: 0 !important;
    }

    /* Renkler kağıtta yansisin. */
    * {
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
    }

    /* Tablo basligi her sayfada tekrarlansin, satir icinden kagit degismesin. */
    table {
        page-break-inside: auto;
    }
    thead {
        display: table-header-group;
    }
    tfoot {
        display: table-footer-group;
    }
    tr {
        page-break-inside: avoid;
        page-break-after: auto;
    }

    /* Ekranda stats-box'lar cok yer kapliyor; yazdirmada kendi basligimizi kullaniyoruz. */
    .row > .col-md-6:has(.stats-box),
    .row > .col-md-12:has(.stats-box),
    hr {
        display: none !important;
    }
}
</style>